@if (!disableTopShadow && showTopShadow) {
<div class="sg-top-shadow"></div>
}
<ng-content></ng-content>
@if (!disableBottomShadow && showBottomShadow) {
<div class="sg-bottom-shadow"></div>
}
